<template>
	
	<div id="main-content" :class="{loading : !app_loaded}">
		<router-view v-if="app_loaded" v-slot="{ Component, route }">
			<transition :name="route.meta.transition">
				<component :is="Component" />
			</transition>
		</router-view>
		
		<nav v-if="app_loaded" class="dashboard-menu-holder admin-menu-holder grayscale inverse">
			<div class="background ">
				<div class="main-column">
					<div class="dashboard-menu admin-menu" v-if="mode == 'admin' || mode == 'secretary'">
						<router-link to="/" :tooltip="locale.tooltips.home">
							<span class="text opacity-lowest material-symbols-rounded">home</span>
						</router-link>
						<router-link to="/checkinout" :tooltip="locale.tooltips.checkinout">
							<span class="text opacity-lowest material-symbols-rounded">timer</span>
						</router-link>
						<router-link to="/gestione-calendario" :tooltip="locale.tooltips.calendar">
							<span class="text opacity-lowest material-symbols-rounded">calendar_month</span>
						</router-link>
						<router-link to="/ricerca" :tooltip="locale.tooltips.search">
							<span class="text opacity-lowest material-symbols-rounded">person_search</span>
						</router-link>
						<router-link to="/gestione-eventi" :tooltip="locale.tooltips.events">
							<span class="text opacity-lowest material-symbols-rounded">celebration</span>
						</router-link>
						<router-link to="/ordini" :tooltip="locale.tooltips.orders">
							<span class="text opacity-lowest material-symbols-rounded">attach_money</span>
						</router-link>
					</div>
					
					<div class="dashboard-menu admin-menu" v-if="mode == 'user'">
						<router-link to="/" :tooltip="locale.dashboard.dashboard">
							<span class="text opacity-lowest material-symbols-rounded">home</span>
						</router-link>
						<router-link to="/prenotazioni" :tooltip="locale.calendar.reservations">
							<span class="text opacity-lowest material-symbols-rounded">timer</span>
						</router-link>
						<router-link to="/calendario" :tooltip="locale.tooltips.calendar">
							<span class="text opacity-lowest material-symbols-rounded">calendar_month</span>
						</router-link>
						<router-link to="/info" :tooltip="locale.tooltips.info">
							<span class="text opacity-lowest material-symbols-rounded">person</span>
						</router-link>
						<router-link to="/eventi" :tooltip="locale.events.events_and_activities">
							<span class="text opacity-lowest material-symbols-rounded">celebration</span>
						</router-link>
					</div>
				</div>
			</div>
		</nav>
	</div>
		
	<transition name="fade">
		<div class="app-loading" v-if="!app_loaded">
			<Loading />
		</div>
	</transition>
	
	<div class="document-container" v-if="current_document">
		<div class="document-body" v-html="current_document.html"></div>
	</div>
</template>

<script>
	import axios from 'axios';
	import { mapState, mapMutations } from 'vuex'
	import { commonMixin } from '@/mixins/common.js';
	import Loading from '@/components/UI/Loading.vue';
	
	export default {
		mixins: [ commonMixin ],
		components: { Loading },
		computed: {
			...mapState([ 'app_loaded', 'base_url', 'nonce', 'mode', 'current_document' ]),
		},
		mounted(){
			this.getGeneralData();
			setInterval(this.updateTime, 1000);
		},
		methods: {
			...mapMutations([ 'updateTime', 'setDocument' ])
		},
	}
</script>

<style lang="scss">
	@use "sass:list";
	@import './assets/styles/base.scss';
	
	/* COLORS */

	@function get-var($context:'surface', $element, $type, $grade:'standard') {
		@return var(--#{$context}-#{$element}-#{$type}-#{$grade} );
	}
	@function get-var-text($context:'surface', $type, $grade:'standard') {
		@return var(--#{$context}-#{$type}-#{$grade} );
	}
	@function get-var-text($context:'surface', $type, $grade:'standard') {
		@return var(--#{$context}-#{$type}-#{$grade} );
	}
	
	$types: 'primary','secondary','tertiary','quaternary','grayscale';
	$elements: 'background','container','object';
	$grades: 'lowest','lower','low','high','higher','highest','inverse';
	$text_grades: 'basic-variant','container','opacity-lowest','opacity-low','opacity-high','opacity-highest','inverse';
	$object_grades: 'standard-dim','low-dim','high-dim','high-bright','standard-bright','low-light';

	@each $type in $types {
		@each $element in $elements {
			.#{$type}-color .#{$element} {
				background: get-var('surface', $element, $type );
			}
			@each $grade in $grades {
				.#{$type}-color .#{$element}.#{$grade} {
					background: get-var('surface', $element, $type, $grade );
				}
			}
		}
		
		.#{$type}-color .object {
			background: get-var('surface', 'object', $type );
		}
		@each $grade in $grades {
			.#{$type}-color .object.#{$grade} {
				background: get-var('surface', 'object', $type, $grade );
			}
		}
		
		.#{$type}-color .text {
			color: get-var-text('text-on', $type );
		}
		@each $grade in $text_grades {
			.#{$type}-color .text.#{$grade} {
				color: get-var-text('text-on', $type, $grade );
			}
		}
	}
	
	.grayscale{
		background: get-var('surface', 'background', 'grayscale' );
	}
	.grayscale .text{
		color: get-var-text('text-on', 'grayscale' );
	}
	@each $grade in $text_grades {
		.grayscale .text.#{$grade} {
			color: get-var-text('text-on', 'grayscale', $grade );
		}
	}
	@each $grade in $grades {
		.grayscale.#{$grade} {
			background: get-var('surface', 'background', 'grayscale', $grade );
		}
		.grayscale.#{$grade} .text{
			color: get-var-text('text-on', 'grayscale', $grade );
		}
		@each $grade in $text_grades {
			.grayscale .text.#{$grade} {
				color: get-var-text('text-on', 'grayscale', $grade );
			}
		}
	}
	
	/* CONTENT */
	
	#main-content{
		position: relative;
		opacity: 1;
		transition: opacity 0.3s;
		width: 100%;
		min-height: 100vh;
		overflow: hidden;
		
		> div{
			width: 100%;
			min-height: 100vh;
		}
		
		&.loading{
			opacity: 0;
		}
	}
	
	.vue-app #main-content{
		min-height: calc(100vh - 5.5rem);
		
		> div{
			min-height: calc(100vh - 5.5rem);
		}
	}
	
	/* MENU */
		
	.dashboard-menu-holder {
		position: fixed;
		z-index: 100;
		bottom: 0;
		width: 100%;
		box-shadow: 0px -3px 6px 0px rgba(0, 0, 0, 0.2);
			
		.dashboard-menu {
			list-style: none;
			white-space: nowrap;
			display: flex;
			
			a{
				display: block;
				flex-grow: 1;
				cursor: pointer;
				text-decoration: none;
				color: inherit;
				
				span{
					display: block;
					font-size: 32px;
					line-height: 1;
					text-align: center;
					text-decoration: none;
					margin: 10px auto;
					border-radius: 50%;
				}
				
				&:hover span{
					fill-opacity: 1;
				}
			}
		}
	}
	
	/* LOADING */
	
	.app-loading{
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
	}
	
	/* PRINT */
	
	.document-container{
		display: none;
	}
	
	@media print{
		#main-content,
		.dashboard-menu-holder{
			display: none;
		}
		.document-container{
			display: block;
			position: relative;
			
			.page-header{
				margin: 1em; 
				
				.logo{
					height: 70px;
					width: auto;
					margin-right: 30px;
				}
			}
			.document-body{
				@page {
					size: auto;
					margin: 0mm;
				}
				.page-break{
					page-break-before: always;
					break-before: page;
				}
				p,ul{
					font-size: 14px;
					margin: 1em;  
					line-height: 1.5;
				}
				ul{   
					margin-left: 3em;
					
					li{
						position: relative;
						margin-bottom: 0.2em;
						
						&:before{
							content: '';
							position: absolute;
							top: 3px;
							right: calc(100% + 5px);
							width: 12px;
							height: 12px;
							border: 1px solid black;
							border-radius: 100%;
							
						}
					}
				}
				.wp-block-columns{
					display: flex;  
					
					> *{
						width: 100%;
					}
				}
			}
		}
	}
</style>
